export const ORDER_TEXT_FILTERS = [
  'storeName',
  'orderNo',
  'platformOrderNo',
  'customerId',
  'receivingCountry',
  'receivingName',
  'receivingPhone',
  'logisticsType',
  'carrier',
  'startDate',
  'endDate',
];
export const PAGE_SIZES = [10, 20, 50, 100, 200, 500, 1000, 2000, 5000];
export const readOrderQuery = (params) => {
  const pageNum = Number(params.get('pageNum'));
  const pageSize = Number(params.get('pageSize'));
  const query = {
    pageNum: Number.isSafeInteger(pageNum) && pageNum > 0 ? pageNum : 1,
    pageSize: PAGE_SIZES.includes(pageSize) ? pageSize : 50,
    sortBy: ['id', 'createTime'].includes(params.get('sortBy'))
      ? params.get('sortBy')
      : 'createTime',
    sortDirection: params.get('sortDirection') === 'asc' ? 'asc' : 'desc',
  };
  ORDER_TEXT_FILTERS.forEach((key) => {
    if (params.get(key)?.trim()) query[key] = params.get(key).trim();
  });
  [
    ['statusList', [0, 1, 2, 91, 92, 99]],
    ['amzStatusList', [0, 1, 2, 3, 99]],
  ].forEach(([key, allowed]) => {
    const values = [
      ...new Set(
        (params.get(key) || '')
          .split(',')
          .filter(Boolean)
          .map(Number)
          .filter((value) => allowed.includes(value)),
      ),
    ];
    if (values.length) query[key] = values;
  });
  return query;
};
export const writeOrderQuery = (query, view = 'query') => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      (!Array.isArray(value) || value.length)
    )
      params.set(key, String(value));
  });
  if (view !== 'query') params.set('view', view);
  return params;
};
